import { wakeUpQQ } from '@tencent/h5-share-enhance';
import React, { useRef } from 'react';
import { mergeCssStyles } from '../../../lib/utils';
import style from './index.module.scss';
const AdBanner = ({ adBannerBackUrl, adBannerUrl, adBannerSchema, adScrollIcon, adBannerGif, onClickBanner, styleCustom, children, isUseDefaultAction = true, }) => {
    const adRef = useRef(null);
    const clickAdIcon = () => {
        adRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const jumpQQ = () => {
        wakeUpQQ(adBannerSchema, {
            downloadWhenWakeupFail: true,
            androidDownloadUrl: 'http://im.qq.com/mobileqq/',
            iOSDownloadUrl: 'itms-apps://itunes.apple.com/cn/app/qq-2011/id444934666?mt=8',
        });
    };
    const mergeStyle = styleCustom ? mergeCssStyles(style, styleCustom) : style;
    return (React.createElement("div", { className: mergeStyle['ad-banner'], style: { backgroundImage: `url(${adBannerBackUrl})` }, ref: adRef, onClick: () => clickAdIcon() },
        React.createElement("div", { className: mergeStyle['ad-banner-wrapper'] },
            adScrollIcon ? (React.createElement("div", { className: mergeStyle['scroll-icon'] },
                React.createElement("img", { src: adScrollIcon, alt: "alt" }))) : null,
            React.createElement("img", { className: mergeStyle['content'], src: adBannerUrl, onClick: () => {
                    onClickBanner === null || onClickBanner === void 0 ? void 0 : onClickBanner();
                    if (isUseDefaultAction) {
                        jumpQQ();
                    }
                }, alt: "" }),
            adBannerGif ? (React.createElement("img", { src: adBannerGif, alt: "", className: mergeStyle['ad-banner-gif'] })) : null,
            children)));
};
export default AdBanner;
